import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import history from '../../../history'

import GenericRow from '../../../GenericComponents/GenericRow'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import { FooterArrow } from '../style/LandingStyle'

interface FooterInterface { }

const Footer: FC<FooterInterface> = ({ }) => {

  const pushToLogin = () => {
    history.push("/zaloguj")
  }


  return (
    <GenericRow width={"100%"} justify="space-between" className="landing footer" padding={isMobile ? "0.25rem 4% 1.25rem 4%" : "3.25rem 20% 1.25rem 20%"}>

      {/* <GenericColumn width={"30%"} flexDir={isMobile ? "column" : "row"}>

        <GenericButton tAlign={"left"} justify={"left"} width="10%" className="no-borders-btn">Lorem</GenericButton>
        <GenericButton tAlign={"left"} justify={"left"} width="10%" className="no-borders-btn">Ipsum</GenericButton>
        <GenericButton tAlign={"left"} justify={"left"} width="10%" className="no-borders-btn">Dolor</GenericButton>
      </GenericColumn> */}
      <GenericColumn width={"100%"} justify={isMobile ? "center" : "flex-end"} align={isMobile ? "center" : "flex-end"}>

        <GenericButton onClick={pushToLogin} padding={"15px 50px"} borderRadius={"30px"} className="promo-outline-btn" width={isMobile ? "40%" : "max-content"}>ZALOGUJ</GenericButton>
      </GenericColumn>

      <GenericRow justify="space-between" padding={isMobile ? "0.25rem 0 2.25rem 0" : "7.25rem 0 2.25rem 0"}>
        <GenericRow justify="start" width={"33%"}>

          <GenericLogo width="25vw" height={"7vh"} />
        </GenericRow>
        {/* <GenericButton padding="15px 50px" borderRadius={"30px"} className="promo-outline-btn" width="max-content">ZALOGUJ</GenericButton>
         */}
        <GenericRow width={"33%"}>

          <GenericTextSpan fSize="0.8rem">© Miazga 2022. Wszystkie prawa zastrzeżone.</GenericTextSpan>
        </GenericRow>
        <GenericRow justify="end" width={"33%"}>

          <GenericTextSpan className="link" fSize="0.8rem"><a href="https://fitmatkawariatka.pl/polityka-prywatnosci/" target="_blank">Polityka prywatności</a></GenericTextSpan>
          <FooterArrow />
        </GenericRow>
      </GenericRow>

    </GenericRow>
  )
}

export default Footer
